import { render, staticRenderFns } from "./SearchProductsDialog.vue?vue&type=template&id=6b32e828&scoped=true&"
import script from "./SearchProductsDialog.vue?vue&type=script&lang=js&"
export * from "./SearchProductsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b32e828",
  null
  
)

export default component.exports